import { call, put, takeLatest } from 'redux-saga/effects';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { getNotificationErrorMessage } from './helpers';

function* remove({ payload: { auditId } }) {
  try {
    yield call(dataProvider.deleteList, `audit/${auditId}`);
    yield put({ type: psmAuditDigital.remove.end, payload: { auditId } });
  } catch (e) {
    yield put({ type: psmAuditDigital.remove.error, payload: { auditId } });
    yield put({ type: notification.add, payload: { error: getNotificationErrorMessage(e, 'Failed to delete audit') } });
  }
}

export default function* removeSaga() {
  yield takeLatest(psmAuditDigital.remove.start, remove);
}
